/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ServiceAmount.vue?vue&type=template&id=73ce6358&scoped=true&"
import script from "./ServiceAmount.vue?vue&type=script&lang=js&"
export * from "./ServiceAmount.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAmount.vue?vue&type=style&index=0&id=73ce6358&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ce6358",
  null
  
)

export default component.exports